import Announcement from "./Announcement";
import Appeal from "./Appeal";
import City from "./City";
import Discipline from "./Discipline";
import DocumentType from "./DocumentType";
import Education from "./Education";
import File from "./File";
import Location from "./Location";
import LocationStep from "./LocationStep";
import Material from "./Material";
import Me from "./Me";
import Message from "./Message";
import Olympiad from "./Olympiad";
import OlympiadStep from "./OlympiadStep";
import PivotalDate from "./PivotalDate";
import Participant from "./Participant";
import Passport from "./Passport";
import Password from "./Password";
import PersonalData from "./PersonalData";
import Region from "./Region";
import ScoreCriterion from "./ScoreCriterion";
import SignIn from "./SignIn";
import SignOut from "./SignOut";
import SignUp from "./SignUp";
import Solution from "./Solution";
import StudyClass from "./StudyClass";
import User from "./User";
import VerifyEmail from "./VerifyEmail";
import OAuthClient from "./OAuthClient";
import OAuthScope from "./OAuthScope";
import OAuthRefreshToken from "./OAuthRefreshToken";
import FinalStepRequest from "./FinalStepRequest";
import Invitation from "./Invitation";
import PreParticipant from "./PreParticipant";
import Period from "./Period";
import LocationRequest from "./LocationRequest";
import Report from "./Report";
import Variant from "./Variant";
import SettingOlympiad from "./SettingOlympiad";

const ApiRequest = {
  announcement: Announcement,
  appeal: Appeal,
  city: City,
  discipline: Discipline,
  documentType: DocumentType,
  education: Education,
  file: File,
  finalStepRequest: FinalStepRequest,
  invitation: Invitation,
  location: Location,
  locationRequest: LocationRequest,
  locationStep: LocationStep,
  material: Material,
  me: Me,
  message: Message,
  oAuthClient: OAuthClient,
  oAuthRefreshToken: OAuthRefreshToken,
  oAuthScope: OAuthScope,
  olympiad: Olympiad,
  olympiadStep: OlympiadStep,
  participant: Participant,
  passport: Passport,
  password: Password,
  period: Period,
  personalData: PersonalData,
  pivotalDate: PivotalDate,
  preParticipant: PreParticipant,
  region: Region,
  report: Report,
  scoreCriterion: ScoreCriterion,
  settingOlympiad: SettingOlympiad,
  signIn: SignIn,
  signOut: SignOut,
  signUp: SignUp,
  solution: Solution,
  studyClass: StudyClass,
  user: User,
  variant: Variant,
  verifyEmail: VerifyEmail,
}

export default ApiRequest;
